export default "__VITE_ASSET__Bnplw3Jw__"